import React, { useState } from 'react';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import NotificationSettings from './NotificationSettings';
import SimplifiedNotificationSettings from './SimplifiedNotificationSettings';

/**
 * Notification preferences with two views:
 * - Simple (default): the 7 job alerts most users care about, each with
 *   email/SMS/push checkboxes (SimplifiedNotificationSettings).
 * - Advanced: the full per-event matrix (NotificationSettings) for the rare
 *   user who needs fine-grained control.
 *
 * Both views read the user's saved preferences and emit the complete complex
 * structure through the same onPreferencesChange callback, so whichever view
 * was touched last is what gets saved.
 */
const NotificationSettingsPanel = ({
  user,
  onPreferencesChange,
  isAdminEditing = false,
  disabled = false,
}) => {
  const [advanced, setAdvanced] = useState(false);

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
        <FormControlLabel
          control={
            <Switch
              size="small"
              checked={advanced}
              onChange={(e) => setAdvanced(e.target.checked)}
            />
          }
          label={<Typography variant="body2">Advanced settings</Typography>}
        />
      </Box>

      {advanced ? (
        <NotificationSettings
          user={user}
          onPreferencesChange={onPreferencesChange}
          isAdminEditing={isAdminEditing}
          disabled={disabled}
        />
      ) : (
        <SimplifiedNotificationSettings
          user={user}
          onPreferencesChange={onPreferencesChange}
          isAdminEditing={isAdminEditing}
          disabled={disabled}
        />
      )}

      {!advanced && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
          Simple view covers the common job alerts. Turn on Advanced settings for per-event control.
        </Typography>
      )}
    </Box>
  );
};

export default NotificationSettingsPanel;
